module.exports = __webpack_public_path__ + "static/media/AlertDevice.007467ca.svg";